<template>
  <div class="borda">
    <ValidationObserver ref="observer">
      <v-row align="center" class="pt-6">
        <v-col cols="12" md="4" class="py-1">
          <div>Parâmetro:</div>
        </v-col>

        <v-col cols="12" md="6" class="py-1">
          <input-cadu disabled value="Notificação" />
        </v-col>
      </v-row>

      <v-row align="center">
        <v-col cols="12" md="4" class="py-1">
          <div>Tipo de Alerta:</div>
        </v-col>

        <v-col cols="12" md="6">
          <input-cadu :onlyUpperCase="false" disabled v-model="parametroNotificacao.tipoAlerta.nome" />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="4" class="py-1">
          <div>Mensagem do Alerta:</div>
        </v-col>

        <v-col cols="12" md="6">
          <validation-provider name="area" mode="eager" rules="required" ref="mensagemAlerta" v-slot="{ errors }">
            <input-cadu
              :errorMessage="errors[0]"
              :disabled="editarMensagemAlerta"
              :onlyUpperCase="false"
              v-model="parametroNotificacao.mensagemAlerta"
            />
          </validation-provider>
        </v-col>

        <v-col class="py-1 pl-0" align-self="center">
          <button-rounded iconName="edit" :iconSize="16" @click="editarMensagemAlerta = false" />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="4" class="py-1">
          <div>Mensagem da Notificação:</div>
        </v-col>

        <v-col cols="12" md="6">
          <validation-provider name="area" mode="eager" rules="required" ref="mensagemNotificacao" v-slot="{ errors }">
            <input-cadu
              :errorMessage="errors[0]"
              :disabled="editarMensagemNotificacao"
              :onlyUpperCase="false"
              v-model="parametroNotificacao.mensagemNotificacao"
            />
          </validation-provider>
        </v-col>

        <v-col class="py-1 pl-0" align-self="center">
          <button-rounded iconName="edit" :iconSize="16" @click="editarMensagemNotificacao = false" />
        </v-col>
      </v-row>

      <v-row align="center">
        <v-col cols="12" md="4" class="py-1"> <div>Status:</div> </v-col>
        <v-col cols="2" class="pr-0"> {{ parametroNotificacao.status ? 'Ativa' : 'Inativa' }} </v-col>
        <v-col cols="auto" class="py-1"> <switch-cadu v-model="parametroNotificacao.status" /> </v-col>
      </v-row>

      <!-- INPUT DO PERIODO ID 1 -->

      <v-row v-if="parametroNotificacao.periodoId == 1">
        <v-col cols="12" md="4" class="py-1">
          <div>Período de Exibição:</div>
        </v-col>

        <v-col cols="12" md="6" class="py-0">
          <validation-provider
            name="area"
            mode="eager"
            ref="inputPeriodoUm"
            :rules="{
              required: true,
              validaPeriodoIdUm: true,
              validaDiasRepetidos: true
            }"
            v-slot="{ errors }"
          >
            <input-cadu
              onlyRegex
              :regexValidation="'([0-9;])'"
              :errorMessage="errors[0]"
              :disabled="editarPeriodo"
              v-model="parametroNotificacao.periodo"
            />
          </validation-provider>
        </v-col>

        <v-col class="py-0 pl-0" align-self="center">
          <button-rounded iconName="edit" :iconSize="16" @click="editarPeriodo = false" />
        </v-col>
        <v-col cols="12" md="4" class="py-0"> </v-col>
        <v-col cols="12" md="4" class="py-0"> </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="4" class="py-0"> </v-col>

        <v-col cols="12" md="6" class="py-0">
          <p v-if="parametroNotificacao.periodoId == 1">
            * Informe os dias do mês para exibição da notificação, separados por ; (Ex: 01;02;03;).
          </p>
        </v-col>
      </v-row>

      <!-- INPUT DO PERÍODO ID 2 -->

      <v-row v-if="parametroNotificacao.periodoId == 2">
        <v-col cols="12" md="4" class="py-1">
          <div>Período de Exibição:</div>
        </v-col>

        <v-col cols="12" md="6" class="py-0">
          <validation-provider
            name="area"
            mode="eager"
            :rules="{
              required: true,
              validaPeriodoZero: true
            }"
            ref="inputPeriodoDois"
            v-slot="{ errors }"
          >
            <input-cadu
              mask="##"
              onlyNumber
              :errorMessage="errors[0]"
              :disabled="editarPeriodo"
              v-model="parametroNotificacao.periodo"
            />
          </validation-provider>
        </v-col>

        <v-col class="py-0 pl-0" align-self="center">
          <button-rounded iconName="edit" :iconSize="16" @click="editarPeriodo = false" />
        </v-col>
        <v-col cols="12" md="4" class="py-0"> </v-col>
        <v-col cols="12" md="4" class="py-0"> </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="4" class="py-0"> </v-col>

        <v-col cols="12" md="6" class="py-0">
          <p v-if="parametroNotificacao.periodoId == 2">* Informe a quantidade de dias após o vencimento.</p>
        </v-col>
      </v-row>

      <!-- INPUT DO PERIODO ID 3 -->

      <v-row v-if="parametroNotificacao.periodoId == 3">
        <v-col cols="12" md="4" class="py-0">
          <div>Período de Exibição:</div>
        </v-col>

        <v-col cols="12" md="6" class="py-0">
          <validation-provider
            name="area"
            mode="eager"
            ref="inputPeriodoAntes"
            :rules="{
              required: true,
              validaPeriodoZero: true
            }"
            v-slot="{ errors }"
          >
            <input-cadu
              mask="##"
              onlyNumber
              :errorMessage="errors[0]"
              :disabled="editarPeriodo"
              :onlyUpperCase="false"
              v-model="periodoAntes"
            />
          </validation-provider>
        </v-col>

        <v-col class="py-0 pl-0" align-self="center">
          <button-rounded iconName="edit" :iconSize="16" @click="editarPeriodo = false" />
        </v-col>

        <v-col cols="12" md="4" class="py-0"> </v-col>

        <v-col cols="12" md="6" class="py-1">
          <p>* Informe a quantidade de dias antes do vencimento.</p>
        </v-col>

        <v-col cols="12" md="4" class="py-0"> </v-col>

        <v-col cols="12" md="6" class="py-0">
          <validation-provider
            name="area"
            mode="eager"
            ref="inputPeriodoDepois"
            :rules="{
              required: true,
              validaPeriodoZero: true
            }"
            v-slot="{ errors }"
          >
            <input-cadu
              mask="##"
              onlyNumber
              :errorMessage="errors[0]"
              :disabled="editarPeriodo"
              :onlyUpperCase="false"
              v-model="periodoDepois"
            />
          </validation-provider>
        </v-col>

        <v-col class="py-0 pl-0" align-self="center">
          <button-rounded iconName="edit" :iconSize="16" @click="editarPeriodo = false" />
        </v-col>

        <v-col cols="12" md="4" class="py-0"> </v-col>
        <v-col cols="12" md="6" class="py-1">
          <p>* Informe a quantidade de dias após o vencimento.</p>
        </v-col>
      </v-row>
    </ValidationObserver>

    <v-row justify="end">
      <v-col cols="auto" class="py-1">
        <button-cadu @click="salvarNotificacao"> SALVAR </button-cadu>
      </v-col>
    </v-row>

    <overlay-loading v-model="loadingOverlay" />

    <error-modal v-model="showError" :errObj="errObj" />

    <SucessoModal
      :genericMessage="'Parâmetro atualizado com sucesso'"
      :showSucess="showSucess"
      @close="showSucess = false"
    />
  </div>
</template>

<script>
import ParametrosGerais from '@/services/ParametrosGerais/ParametrosGerais'
import ErrorMixin from '@/Mixins/ErrorMixin'
import { ValidationObserver, ValidationProvider } from 'vee-validate'

export default {
  mixins: [ErrorMixin],

  components: {
    ValidationObserver,
    ValidationProvider
  },

  props: {
    parametro: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      parametroNotificacao: this.parametro,

      editarMensagemAlerta: true,
      editarMensagemNotificacao: true,
      editarPeriodo: true,

      showSucess: false,

      loadingOverlay: false,

      periodoExibicao: null,

      periodoAntes: this.parametro.periodoId == 3 ? this.parametro.periodo.split('-')[0] : '',
      periodoDepois: this.parametro.periodoId == 3 ? this.parametro.periodo.split('-')[1] : ''
    }
  },

  methods: {
    async salvarNotificacao() {
      const arr = ['mensagemAlerta', 'mensagemNotificacao']
      if (!(await this.validaInputRef(arr))) return

      const parametrosGerais = new ParametrosGerais(localStorage.getItem('tokenBearer'), this.$appConfig.config.API)
      const { id } = this.parametroNotificacao

      if (this.parametroNotificacao.periodoId == 3) {
        if (await this.validaInputRef(['inputPeriodoAntes', 'inputPeriodoDepois']))
          this.parametroNotificacao.periodo = this.periodoAntes + '-' + this.periodoDepois
        else return
      }

      if (this.parametroNotificacao.periodoId == 2) {
        if (!(await this.validaInputRef(['inputPeriodoDois']))) return
      }

      if (this.parametroNotificacao.periodoId == 1) {
        if (this.parametroNotificacao.periodo.slice(-1) != ';') {
          this.parametroNotificacao.periodo = this.parametroNotificacao.periodo + ';'
        }
        if (!(await this.validaInputRef(['inputPeriodoUm']))) return
      }

      this.loadingOverlay = true
      await parametrosGerais
        .putParametroNotificacao(id, this.parametroNotificacao)
        .then(() => (this.showSucess = true))
        .catch((err) => this.setError(err))
        .finally(() => (this.loadingOverlay = false))
    },

    async validaInputRef(arr) {
      let res = await Promise.all(arr.map(async (el) => this.$refs[el].validate()))
      if (res.find((el) => el.valid !== true)) return false
      else return true
    }
  }
}
</script>

<style lang="sass" scoped>
.borda
  border: 1px solid #00995d
  border-radius: 10px
  padding: 10px
</style>
